import { LanguageCode } from "types";

export interface Language {
    code: LanguageCode;
    country: string;
    available: boolean;
}

export const languages: Language[] = [
    {
        code: 'es',
        available: true,
        country: 'Spain, Mexico, Argentina'
    },
    {
        code: 'en',
        available: true,
        country: 'United States, United Kingdom, Australia'
    },
    // {
    //     code: 'zh',
    //     available: false,
    //     country: 'China, Taiwan, Singapore'
    // },
    // {
    //     code: 'hi',
    //     available: false,
    //     country: 'India'
    // },
    // {
    //     code: 'ar',
    //     available: false,
    //     country: 'Saudi Arabia, Egypt, Morocco'
    // },
    // {
    //     code: 'bn',
    //     available: false,
    //     country: 'Bangladesh, India'
    // },
    // {
    //     code: 'ru',
    //     available: false,
    //     country: 'Russia, Ukraine, Belarus'
    // },
    // {
    //     code: 'pt',
    //     available: false,
    //     country: 'Brazil, Portugal'
    // },
    // {
    //     code: 'ja',
    //     available: false,
    //     country: 'Japan'
    // },
    // {
    //     code: 'de',
    //     available: false,
    //     country: 'Germany, Austria, Switzerland'
    // },
]